
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils

import { sortByNameInAlphabeticalOrder } from '@utils/miscellaneous/sortings';


const AttributeItems = props => {

    const {
        deleteItem,
        isDeletable,
        items = []
    } = props;

    return sortByNameInAlphabeticalOrder(items).map(item => {

        const { name, id } = item;

        return (
            <div key = { id } className = 'assignee-attribute'>
                { name }
                {
                    isDeletable &&

                    <div className = "attribute-cross-button">
                        <a
                            href = { undefined }
                            onClick = { () => deleteItem(id) }
                            aria-label = "Close"
                        >
                            <FontAwesomeIcon icon = "times"/>
                        </a>
                    </div>
                }
            </div>
        );
    });
};

export default AttributeItems;